import "./LoginModal.scss";
import React from "react";
import Modal from "../__common/Modal/Modal";
import { Typography } from "../__common/Typography/Typography";
import { Button } from "../__common/_controls";
import { useAuthProvider } from "../../hooks/useAuthProvider";
import { useTranslation } from "react-i18next";
import { Col, Row } from "../Grid/Grid";
import {
  EVENT_ACTION_LOGIN_VIA_EMAIL,
  EVENT_ACTION_LOGIN_VIA_SA,
} from "../../constants/analytics";
import { GA4EventName } from "../../types/analytics";
import { useLoginOptionHooks } from "../../hooks/login-option-hooks";
import { ApplicationState } from "../../store";
import { useSelector } from "react-redux";
import { LoginOptionState } from "../../store/reducers/login-option-reducer";
import { getRedirectUrl } from "../../utils/RedirectURL";
import GoogleAnalyticsV2 from "../../utils/GoogleAnalyticsV2";

interface Props {
  show: boolean;
  onClose: () => void;
  headertestid?: string;
}

export const LoginModal: React.FC<Props> = ({
  show,
  onClose,
  headertestid,
}) => {
  const { login } = useAuthProvider();
  // const query = useQuery();
  const { t } = useTranslation();
  const { toggleEmailLoginModal } = useLoginOptionHooks();
  const { loginModalRedirect } = useSelector<
    ApplicationState,
    LoginOptionState
  >((state) => state.loginOption);
  const handleSaLogin = () => {
    const redirect = getRedirectUrl();

    // close login modal up
    onClose();
    login("SA", { redirectURL: loginModalRedirect || redirect });

    GoogleAnalyticsV2.trackEvent(GA4EventName.LoginAttempt, {
      login_method: EVENT_ACTION_LOGIN_VIA_SA,
    });
  };

  return (
    <Modal
      show={show}
      className="login-modal"
      testId="login-modal"
      id="login-modal"
    >
      <Modal.Header headertestid={headertestid} onHide={onClose}>
        <Modal.Title>{t("PRIVACY_LOGIN_OPTION_MODAL_HEADER")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="login-modal__body">
          <Col sm={12} md={6}>
            <Typography variant="title2">
              {t("PRIVACY_LOGIN_OPTION_TITLE_HEADER1")}
            </Typography>
            <Typography variant="body2" className="subText">
              {t("PRIVACY_LOGIN_OPTION_TEXT1")}
            </Typography>
            <div className="mt20">
              <Button
                variant="solid"
                className="button"
                title={t("PRIVACY_LOGIN_OPTION_BTN_SA")}
                onClick={handleSaLogin}
                testId="login-via-sa-btn"
              />
            </div>
          </Col>
          <Col sm={12} md={6}>
            <div>
              <Typography variant="title2">
                {t("PRIVACY_LOGIN_OPTION_TITLE_HEADER2")}
              </Typography>
              <Typography variant="body2" className="subText">
                {t("PRIVACY_LOGIN_OPTION_TEXT2")}
              </Typography>
            </div>
            <div className="mt20">
              <Button
                title={t("PRIVACY_LOGIN_OPTION_BTN_EMAIL")}
                onClick={() => {
                  GoogleAnalyticsV2.trackEvent(GA4EventName.LoginAttempt, {
                    login_method: EVENT_ACTION_LOGIN_VIA_EMAIL,
                  });
                  onClose();
                  toggleEmailLoginModal(true);
                }}
                // className="button"
                testId="login-via-email-btn"
              />
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
